import './optionSelectorSimple.scss';

import { useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { OPTION_NOT_FOR_EVERYONE, SELECTOR_MODE } from '~constants';
import { addOptionToParticipants, getParticipantsWithOption } from '~helpers';
import { ParticipantsPicker } from '~molecules';
import { AvailableOption } from '~types/appsync.types';
import { Participant } from '~types/participant';

import OptionSelectorContainer from '../OptionSelectorContainer/optionSelectorContainer';

interface OptionSelectorSimpleProps {
  option: AvailableOption;
  participants: Participant[];
  currency: string;
  participantMode: SELECTOR_MODE;
  onParticipantsChange: (participants: Participant[]) => void;
}

const OptionSelectorSimple = ({
  option,
  participants,
  currency,
  participantMode,
  onParticipantsChange,
}: OptionSelectorSimpleProps) => {
  const [forceOpen, setForceOpen] = useState(false);

  const participantsWithOption = getParticipantsWithOption(participants, option.slug);
  const selectedCount = participantsWithOption.length;
  const isNotForEveryone = option.tags.includes(OPTION_NOT_FOR_EVERYONE);

  const handleAddAll = () => {
    setForceOpen(true);
    if (isNotForEveryone) {
      return;
    }
    const allIds = participants.map((p) => p.id);
    const updated = addOptionToParticipants(participants, option, allIds);
    onParticipantsChange(updated);
  };

  const handleRemoveAll = () => {
    setForceOpen(false);
    const updated = addOptionToParticipants(participants, option, []);
    onParticipantsChange(updated);
  };

  const handleSelectParticipants = (selected: Participant[]) => {
    const selectedIds = selected.map((p) => p.id);
    const updated = addOptionToParticipants(participants, option, selectedIds);
    onParticipantsChange(updated);
  };

  return (
    <OptionSelectorContainer
      option={option}
      currency={currency}
      isOptionSelected={selectedCount > 0 || forceOpen}
      selectedCount={selectedCount}
      onAddAll={handleAddAll}
      onRemoveAll={handleRemoveAll}
    >
      <div className='OptionSelectorSimple_participants'>
        <div className='OptionSelectorSimple_sectionTitle'>
          <FormattedMessage
            defaultMessage='Select or deselect participants:'
            id='selectOrDeselectParticipants'
          />
        </div>
        <ParticipantsPicker
          participants={participants}
          participantMode={participantMode}
          selected={participantsWithOption}
          onParticipantsSelect={handleSelectParticipants}
        />
      </div>
    </OptionSelectorContainer>
  );
};

export default OptionSelectorSimple;
